module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic9.173c30a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic9.png
// module id = 592
// module chunks = 1